<template>
    <!-- 详情模块 -->
    <div>
        <div class="page-top-handle">
            <Button type="primary" :loading="loading" @click="handleSubmit">提交</Button>
            <Button type="default" style="margin-left: 8px"  @click="handleBack">取消</Button>
        </div>
        <div class="form-wrapper">
            <div class="ft-box">
                <div class="ft-title aFlex">
                    <Icon class="ft-title-mark" type="md-bookmark" />
                    <span>秘钥编辑</span>
                </div>
                <Form
                        ref="infoForm"
                        :model="infoForm"
                        :rules="ruleLine"
                        inline
                        :label-width="240"
                        class="form-list key__form"
                >
                    <Row :gutter="16">
                        <Col span="12">
                            <FormItem label="项目名称" prop="name">
                                <Input
                                        v-model="infoForm.name"
                                        placeholder="项目名称务必与施工许可证保持一致"
                                        @input="setProjectName"
                                        @on-blur="cancelProject"
                                ></Input>
                                <div class="modalBox" v-show="sceen">
                                    <div
                                            class="modalOne"
                                            v-for="(item, index) in projectNameArr"
                                            :key="index"
                                            @click.stop="chooseProjectName(item)"
                                    >
                                        {{ item.name }}
                                    </div>
                                </div>
                            </FormItem>
                        </Col>
                        <Col span="24">
                            <FormItem label="施工许可证号" prop="buildPermitCode">
                                <div style="display: flex; flex-wrap: wrap">
                                    <Input
                                            style="width: 200px; margin-right: 8px"
                                            v-for="(item, index) in buildPermitCodeArr"
                                            v-model="item.builderLicenseNum"
                                            :key="index"
                                            placeholder="请输入"
                                    >
                                    <span
                                            slot="append"
                                            style="cursor: pointer"
                                            @click="deletePcode(index)"
                                    >x</span
                                    >
                                    </Input>
                                    <Button type="primary" @click="addPcode">添 加</Button>
                                </div>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="项目所在地区" prop="areaCodes">
                                <Cascader
                                        v-model="infoForm.areaCodes"
                                        :data="areaList"
                                        placeholder="请选择"
                                        @on-change="infoCas"
                                ></Cascader>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="项目类别" prop="category">
                                <Select
                                        v-model="infoForm.category"
                                        filterable
                                        clearable
                                        label-in-value
                                        @on-change="infoType"
                                >
                                    <Option
                                            v-for="item in common.projectTypes"
                                            :value="item.value"
                                            :key="item.value"
                                    >{{ item.label }}</Option
                                    >
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="24">
                            <FormItem label="项目状态" prop="prjStatus">
                                <RadioGroup v-model="infoForm.prjStatus">
                                    <Radio
                                            v-for="(item, index) in common.prjStatusS"
                                            :key="index"
                                            :label="item.value"
                                    >{{ item.label }}</Radio
                                    >
                                </RadioGroup>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="项目开工日期（计划开工日期）" prop="startDate">
                                <DatePicker
                                        type="date"
                                        placeholder="请选择"
                                        :value="infoForm.startDate"
                                        @on-change="infoForm.startDate = $event"
                                        :options="{ disabledDate: val => { return this.disabledDateStart(val, infoForm.completeDate)} }"
                                        transfer
                                ></DatePicker>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="项目竣工日期（计划竣工日期）" prop="completeDate">
                                <DatePicker
                                        type="date"
                                        placeholder="请选择"
                                        :value="infoForm.completeDate"
                                        @on-change="infoForm.completeDate = $event"
                                        :options="{ disabledDate: val => { return this.disabledDateEnd(val, infoForm.startDate)} }"
                                        transfer
                                ></DatePicker>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="总投资（万元）" prop="invest">
                                <Input
                                        v-model="infoForm.invest"
                                        type="number"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="总面积（平方米）" prop="buildingArea">
                                <Input
                                        v-model="infoForm.buildingArea"
                                        type="number"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="施工总承包单位名称" prop="contractorCorpName">
                                <Input
                                        v-model="infoForm.contractorCorpName"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem
                                    label="施工总承包单位统一社会信用代码"
                                    prop="contractorCorpCode"
                            >
                                <Input
                                        v-model="infoForm.contractorCorpCode"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="项目经理" prop="pmName">
                                <Input
                                        v-model="infoForm.pmName"
                                        placeholder="请输入"
                                        @input="getPerson"
                                        @on-blur="cancelPerson"
                                ></Input>
                                <div class="modalBox" v-show="sceenPerson">
                                    <div
                                            class="modalOne"
                                            v-for="(item, index) in PersonListArr"
                                            :key="index"
                                            @mouseover="linkOne(item)"
                                            @click.stop="choosePersonName(item)"
                                    >
                                        {{ item.workerName }}
                                        <div class="modalPopul" v-show="item.choose">
                                            <div class="modalPopulOne">名称:{{ infor.workerName }}</div>
                                            <div class="modalPopulOne">
                                                性别:{{ infor.gender == "0" ? "男" : "女" }}
                                            </div>
                                            <div class="modalPopulOne">
                                                岗位类型:{{ infor.manageType }}
                                            </div>
                                            <div class="modalPopulOne">
                                                证件类型:{{ infor.idCardType }}
                                            </div>
                                            <div class="modalPopulOne">
                                                证件号:{{ infor.idCardNumber }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="联系电话" prop="pmPhone">
                                <Input v-model="infoForm.pmPhone" placeholder="请输入"></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="建设单位名称" prop="buildCorpName">
                                <Input
                                        v-model="infoForm.buildCorpName"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="建设单位统一社会信用代码" prop="buildCorpCode">
                                <Input
                                        v-model="infoForm.buildCorpCode"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="建设单位项目负责人" prop="supervisingEngineerName">
                                <Input
                                        v-model="infoForm.supervisingEngineerName"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="联系电话" prop="supervisingEngineerPhone">
                                <Input
                                        v-model="infoForm.supervisingEngineerPhone"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="监理单位名称" prop="adminName">
                                <Input v-model="infoForm.adminName" placeholder="请输入"></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="监理单位统一社会信用代码" prop="adminId">
                                <Input v-model="infoForm.adminId" placeholder="请输入"></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="项目总监" prop="projectDirector">
                                <Input
                                        v-model="infoForm.projectDirector"
                                        placeholder="请输入"
                                        @input="getPersonSecond"
                                        @on-blur="cancelPersonSecond"
                                ></Input>
                                <div class="modalBox" v-show="sceenPersonSecond">
                                    <div
                                            class="modalOne"
                                            v-for="(item, index) in PersonListArrSecond"
                                            :key="index"
                                            @mouseover="linkOneSecond(item)"
                                            @click.stop="choosePersonNameSecond(item)"
                                    >
                                        {{ item.workerName }}
                                        <div class="modalPopul" v-show="item.choose">
                                            <div class="modalPopulOne">名称:{{ infor.workerName }}</div>
                                            <div class="modalPopulOne">
                                                性别:{{ infor.gender == "0" ? "男" : "女" }}
                                            </div>
                                            <div class="modalPopulOne">
                                                岗位类型:{{ infor.manageType }}
                                            </div>
                                            <div class="modalPopulOne">
                                                证件类型:{{ infor.idCardType }}
                                            </div>
                                            <div class="modalPopulOne">
                                                证件号:{{ infor.idCardNumber }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="联系电话" prop="projectDirectorPhone">
                                <Input
                                        v-model="infoForm.projectDirectorPhone"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <!--<Col span="12">-->
                        <!--<FormItem label="总监理工程师" prop="supervisingEngineerName">-->
                        <!--<Input v-model="infoForm.supervisingEngineerName" placeholder="请输入"></Input>-->
                        <!--</FormItem>-->
                        <!--</Col>-->
                        <Col span="12">
                            <FormItem label="设备安装公司名称" prop="equipmentCompanyName">
                                <Input
                                        v-model="infoForm.equipmentCompanyName"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="设备安装公司电话" prop="equipmentCompanyMobile">
                                <Input
                                        v-model="infoForm.equipmentCompanyMobile"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="项目实名制负责人姓名" prop="applicantName">
                                <Input
                                        v-model="infoForm.applicantName"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="项目实名制负责人联系电话" prop="applicantMobile">
                                <Input
                                        v-model="infoForm.applicantMobile"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="项目实名制负责人邮箱" prop="email">
                                <Input v-model="infoForm.email" placeholder="请输入"></Input>
                            </FormItem>
                        </Col>
                        <Col span="24">
                            <FormItem label="备注" prop="remark">
                                <Input
                                        v-model="infoForm.remark"
                                        type="textarea"
                                        :rows="3"
                                        placeholder="请输入"
                                ></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    </div>

</template>
<style scoped>

</style>
<script>
    import { getProjectTokenDetail, projectTokenEditSave } from '@/api/platform'
    import { getCounties } from '@/api/user';
    export default {
        components: {

        },
        data(){
            const valiuserCode = (rule, value, callback) => {
                if (value.length !== 18 && value.length !== 9) {
                    callback(new Error('必须9或者18位字符!'));
                } else {
                    callback();
                }
            };
            const validStrForPhoneNum = (rule, value, callback) => {
                let r = '';
                const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (value === '' || value === undefined) {
                    r = '请输入手机号';
                } else if (typeof value === 'string' && !reg.test(value)) {
                    r = '手机号格式错误';
                }
                if (r) {
                    callback(new Error(r));
                } else {
                    callback();
                }
            };
            return {
                loading: false,
                tProjectTokenId:'',
                infoForm: {
                    name: '',
                    buildPermitCode: '',
                    areaCodes: [],
                    provinceCode: '',
                    provinceName: '',
                    cityCode: '',
                    cityName: '',
                    countyCode: '',
                    countyName: '',
                    // areaCode: '',
                    // areaName: '',
                    category: '',
                    projectTypeName: '',
                    prjStatus: '',
                    contractorCorpName: '',
                    contractorCorpCode: '',
                    startDate: '',
                    completeDate: '',
                    invest: '',
                    buildingArea: '',
                    buildCorpName: '',
                    buildCorpCode: '',
                    pmName: '',
                    supervisingEngineerName: '',
                    equipmentCompanyName: '',
                    equipmentCompanyMobile: '',
                    applicantName: '',
                    applicantMobile: '',
                    email: '',
                    remark: '',
                    pmPhone: '',
                    supervisingEngineerPhone: '',
                    adminName: '',
                    adminId: '',
                    projectDirector: '',
                    projectDirectorPhone: '',
                },
                ruleLine: {
                    name: [
                        { required: true, message: '请输入项目名称', trigger: 'blur' }
                    ],
                    areaCodes: [
                        {
                            required: true,
                            type: 'array',
                            min: 1,
                            message: '项目所在地区不能为空',
                            trigger: 'change',
                        },
                    ],
                    category: [
                        { required: true, message: '项目类别不能为空', trigger: 'change' },
                    ],
                    prjStatus: [
                        { required: true, message: '项目状态不能为空', trigger: 'change' },
                    ],
                    contractorCorpName: [
                        {
                            required: true,
                            message: '请输入施工总承包单位名称',
                            trigger: 'blur',
                        },
                    ],
                    contractorCorpCode: [
                        {required: true, message: '请输入施工总承包单位统一社会信用代码', trigger: 'blur',},
                        { validator: valiuserCode, trigger: 'blur'},
                    ],
                    pmName: [
                        { required: true, message: '请输入项目经理', trigger: 'submit' },
                    ],
                    buildCorpName: [
                        { required: true, message: '请输入建设单位名称', trigger: 'blur' },
                    ],
                    buildCorpCode: [
                        {
                            required: true,
                            message: '请输入建设单位统一社会信用代码',
                            trigger: 'blur',
                        },
                        { validator: valiuserCode, trigger: 'blur'},
                    ],
                    supervisingEngineerName: [
                        {
                            required: true,
                            message: '请输入建设单位项目负责人',
                            trigger: 'blur',
                        },
                    ],
                    adminName: [
                        { required: true, message: '请输入监理单位名称', trigger: 'blur' },
                    ],
                    adminId: [
                        {
                            required: true,
                            message: '请输入监理单位统一社会信用代码',
                            trigger: 'blur',
                        },
                        { validator: valiuserCode, trigger: 'blur'},
                    ],
                    projectDirector: [
                        { required: true, message: '请输入项目总监', trigger: 'submit' },
                    ],
                    applicantName: [
                        {
                            required: true,
                            message: '请输入项目实名制负责人姓名',
                            trigger: 'blur',
                        },
                    ],
                    applicantMobile: [
                        { required: true, validator: validStrForPhoneNum, trigger: 'blur' },
                    ],
                    email: [
                        { required: true, message: '邮箱地址不能为空', trigger: 'blur' },
                        { type: 'email', message: '邮箱地址格式不正确', trigger: 'blur' },
                    ],
                },
                sceen: false,
                sceenPerson: false,
                sceenPersonSecond: false,
                PersonListArrSecond: [],
                PersonListArr: [],
                projectNameArr: [],
                infor: {},
                buildPermitCodeArr: [{ builderLicenseNum: '' }],
                areaList: [],


            };
        },
        computed:{
        },
        created(){
            this.tProjectTokenId= this.$route.query.tProjectTokenId;
            this.getPageData();
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            disabledDateStart(val, date) {
                return (
                    new Date(date || '').getTime() - 24 * 3600 * 1000 < val.getTime()
                );
            },
            disabledDateEnd(val, date) {
                return (
                    new Date(date || '').getTime() > val.getTime()
                );
            },
            /*获取页面信息*/
            getPageData(){
                this.getCounties();
                this.getProjectTokenDetail();
            },
            handleSubmit() {
                this.$refs.infoForm.validate((valid) => {
                    if (valid) {
                        const params = {
                            ...this.infoForm,
                        };
                        const arr = this.buildPermitCodeArr.map((item) => {
                            return item.builderLicenseNum;
                        });
                        params.buildPermitCode = [...new Set(arr)].join(';');
                        this.loading = true;
                        projectTokenEditSave(params).then((res) => {
                            this.loading = false;
                            if (res.data.success) {
                                this.$Message.success(res.data.data || '编辑成功!');
                                this.$router.go(-1);
                            } else {

                            }
                        }).catch(() => {
                            this.loading = false;
                        });
                    }
                });
            },
            getCounties() {
                const code = localStorage.getItem('tenantAreaCode').slice(0,2) * 10000;
                getCounties(code).then((res) => {
                    this.areaList = res.data.data || [];
                });
            },
            getProjectTokenDetail() {
                getProjectTokenDetail({
                    tProjectTokenId: this.tProjectTokenId,
                }).then(res => {
                    if(res.data.success){
                        const data = res.data.data || {};
                        data.areaCodes = [data.provinceCode, data.cityCode,data.countyCode];
                        if(data.areaName){
                            let arr = data.areaName.split('-');
                            data.provinceName = arr[0];
                            data.cityName = arr[1];
                            data.countyName = arr[2];
                        }

                        if(data.buildPermitCode) {
                            this.buildPermitCodeArr = data.buildPermitCode.split(';').map(item=> {
                                return {
                                    builderLicenseNum: item
                                }
                            })
                        }
                        Object.assign(this.infoForm, data)
                    }
                })
            },
            handleBack() {
                this.$router.go(-1);
            },
            // 项目类别选择
            infoType(data) {
                this.infoForm.projectTypeName = data.label;
            },
            // 地区选择
            infoCas(val, data) {
                const len = data.length;
                this.infoForm.provinceCode = data[len - 3].value;
                this.infoForm.provinceName = data[len - 3].label;
                this.infoForm.cityCode = data[len - 2].value;
                this.infoForm.cityName = data[len - 2].label;
                this.infoForm.countyCode = data[len - 1].value;
                this.infoForm.countyName = data[len - 1].label;
            },
            // 施工许可证号 - 添加
            addPcode() {
                this.buildPermitCodeArr.push({ builderLicenseNum: '' });
            },
            // 施工许可证号 - 移除
            deletePcode(index) {
                this.buildPermitCodeArr.splice(index, 1);
            },
            // 模糊检索项目经理
            getPerson(e) {
                console.log(e);
                this.axios({
                    method: 'get',
                    url: '/integration/getProjectManagerByName',
                    params: {
                        workerName: e,
                    },
                }).then((res) => {
                    console.log(res);
                    if (res.data.data.length > 0) {
                        this.sceenPerson = true;
                    }
                    res.data.data.forEach((item) => {
                        item.choose = false;
                    });
                    this.PersonListArr = res.data.data;
                });
            },
            // 项目经理 - 失去焦点
            cancelPerson() {
                setTimeout(() => {
                    this.sceenPerson = false;
                }, 200);
            },
            // 选择项目经理
            choosePersonName(item) {
                this.infoForm.pmName = item.workerName;
                this.sceenPerson = false;
            },
            linkOne(e) {
                this.getPersonInfor(e.id);
                this.PersonListArr.forEach((item) => {
                    if (e.id == item.id) {
                        item.choose = true;
                    } else {
                        item.choose = false;
                    }
                });
            },
            linkOneSecond(e) {
                this.getPersonInfor(e.id);
                this.PersonListArrSecond.forEach((item) => {
                    if (e.id == item.id) {
                        item.choose = true;
                    } else {
                        item.choose = false;
                    }
                });
            },
            // 获取项目经理详情
            getPersonInfor(id) {
                this.axios({
                    method: 'get',
                    url: '/integration/getProjectManagerById',
                    params: {
                        workerId: id,
                    },
                }).then((res) => {
                    this.infor = res.data.data;
                });
            },
            // 项目总监
            getPersonSecond(e) {
                // console.log(e);
                this.axios({
                    method: 'get',
                    url: '/integration/getProjectManagerByName',
                    params: {
                        workerName: e,
                    },
                }).then((res) => {
                    // console.log(res);
                    if (res.data.data.length > 0) {
                        this.sceenPersonSecond = true;
                    }
                    res.data.data.forEach((item) => {
                        item.choose = false;
                    });
                    this.PersonListArrSecond = res.data.data;
                });
            },
            cancelPersonSecond() {
                setTimeout(() => {
                    this.sceenPersonSecond = false;
                }, 200);
            },
            // 选择项目总监
            choosePersonNameSecond(item) {
                this.infoForm.projectDirector = item.workerName;
                this.sceenPerson = false;
            },
            // 模糊检索项目信息
            setProjectName(e) {
                // console.log(e);
                if (e) {
                    this.axios({
                        method: 'get',
                        url: '/integration/getProjectByName',
                        params: {
                            projectName: e,
                        },
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.data.length > 0) {
                            this.sceen = true;
                        }
                        this.projectNameArr = res.data.data;
                        // this.getPersonList(name);
                    });
                } else {
                    this.$refs.infoForm.resetFields();
                    this.buildPermitCodeArr = [];
                    this.infoForm.areaCode = [];
                }
            },
            // 项目信息 - 失去焦点
            cancelProject() {
                setTimeout(() => {
                    this.sceen = false;
                }, 200);
            },
            // 选择项目名称
            chooseProjectName(item) {
                this.infoForm.name = item.name;
                this.getChildInfor(item.id);
                this.sceen = false;
            },
            getChildInfor(id) {
                this.axios({
                    method: 'get',
                    url: '/integration/getProjectById',
                    params: {
                        projectId: id,
                    },
                }).then((res) => {
                    this.infoForm = res.data.data;
                    this.buildPermitCodeArr = res.data.data.builderLicenseList;
                    const nodes = res.data.data.areaCodes;
                    // console.log(nodes.length);
                    if (nodes.length == 0) {
                        this.infoForm.areaCodes = ['', '', ''];
                    } else if (nodes.length == 1) {
                        this.infoForm.areaCodeS = [nodes[0].value, '', ''];
                        this.infoForm.provinceCode = nodes[0].value;
                        this.infoForm.provinceName = nodes[0].name;
                    } else if (nodes.length == 2) {
                        this.infoForm.areaCodes = [nodes[0].value, nodes[1].value, ''];
                        this.infoForm.provinceCode = nodes[0].value;
                        this.infoForm.provinceName = nodes[0].name;
                        this.infoForm.cityCode = nodes[1].value;
                        this.infoForm.cityName = nodes[1].name;
                    } else if (nodes.length == 3) {
                        this.infoForm.areaCodes = [
                            nodes[0].value,
                            nodes[1].value,
                            nodes[2].value,
                        ];
                        this.infoForm.provinceCode = nodes[0].value;
                        this.infoForm.provinceName = nodes[0].name;
                        this.infoForm.cityCode = nodes[1].value;
                        this.infoForm.cityName = nodes[1].name;
                        this.infoForm.countyCode = nodes[2].value;
                        this.infoForm.countyName = nodes[2].name;
                    }
                });
            },

        }
    };
</script>
<style scoped lang="less">
    /deep/.key__form {
        .ivu-select-dropdown {
            height: 340px;
            max-height: 340px;
        }
        .ivu-cascader-menu {
            height: auto;
            max-height: 335px;
        }
    }
    // 模态框样式
    .modalBox {
        width: 100%;
        position: absolute;
        top: 35px;
        left: 0;
        z-index: 8;
        background: #fff;
        border-radius: 5px;
        box-shadow: 2px 2px 5px #888888;
        .modalOne {
            padding: 0 10px;
            box-sizing: border-box;
            position: relative;
            &:hover {
                background: #f2f2f2;
            }
            .modalPopul {
                background: #fff;
                position: absolute;
                width: 220px;
                right: -230px;
                top: -70px;
                padding: 0 10px;
                box-sizing: border-box;
                border: 1px solid #dcdee2;
                box-shadow: 2px 2px 5px #f2f2f2;
                border-radius: 5px;
                &::before {
                    content: "";
                    position: absolute;
                    width: 0;
                    height: 0;
                    top: 50%;
                    left: -4px;
                    transform: translate(-50%, 0);
                    border-top: 5px solid transparent;
                    border-bottom: 5px solid transparent;
                    border-right: 8px solid #dcdee2;
                }
            }
        }
    }
</style>
<style scoped lang="less"></style>
